export default __webpack_public_path__ + "static/media/19.7197b045.jpeg";